import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Carousel from "react-multi-carousel";
import WorkerImg1 from "../../assets/images/Leticia.jpg";
import WorkerImg2 from "../../assets/images/Cleonice.jpg";
import WorkerImg3 from "../../assets/images/Ederson.jpg";
import WorkerImg4 from "../../assets/images/Maria.jpg";
import WorkerImg5 from "../../assets/images/Lidiane.jpg";
import WorkerImg6 from "../../assets/images/Cristhiane.jpg";
import "./Testimony.css";

export default function Testimony(props) {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 990, min: 576 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 576, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <Container className="testimony-section">
      <Row>
        <Col className="testimony-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            Quem faz o Grupo Krause conta como é trabalhar aqui!
          </h2>
        </Col>
      </Row>
      <Carousel
        showDots={false}
        responsive={responsive}
        transitionDuration={500}
        containerClass="testimony-carousel-container"
        infinite={true}
      >
        <div className="testimony-card">
          <div className="testimony-card-title">
            <img
              src={WorkerImg1}
              alt="Colaborador"
              className="testimony-card-img"
            />
            <div>
              <h3
                style={{
                  color: props.titleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Letícia Stelter
              </h3>
              <h4 style={{ color: props.textColor, fontSize: props.textSize }}>
                Consultora de Relacionamento
              </h4>
            </div>
          </div>
          <p style={{ color: props.textColor, fontSize: props.subTextSize }}>
            "São 3 anos no Grupo, iniciei como Auxiliar administrativo e após 2
            anos tive a oportunidade de mudar para o cargo de Consultora de
            Relacionamento com o cliente. Hoje vejo o quanto este grupo valoriza
            seus colaboradores e clientes. Sinto que estou no lugar e no momento
            certo e que as vezes só precisamos esperar que as oportunidades
            chegam no momento exato. Eu só tenho a agradecer por tudo e gostaria
            de dizer que seja qual for a sua função, sempre faça com excelência
            que a recompensa vai chegar"
          </p>
        </div>
        <div style={{ background: props.white }} className="testimony-card">
          <div className="testimony-card-title">
            <img
              src={WorkerImg2}
              alt="Colaborador"
              className="testimony-card-img"
            />
            <div>
              <h3
                style={{
                  color: props.titleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Cleonice da Rosa
              </h3>
              <h4 style={{ color: props.textColor, fontSize: props.textSize }}>
                Assistente Administrativo Pleno
              </h4>
            </div>
          </div>
          <p style={{ color: props.textColor, fontSize: props.subTextSize }}>
            "Minha trajetória no Grupo Krause iniciou em 2017 como Auxiliar Adm.
            Em 2020 passei atuar como Assistente Adm Jr. Em 2022 recebi a
            oportunidade para o cargo de Assistente Adm Pleno, meu cargo atual.
            Mais de 6 anos no Grupo, empresa que valoriza a dedicação dos
            funcionários, e acima de tudo valoriza o ser humano. Com orgulho
            sigo essa trajetória, trabalhando com o que gosto num ambiente
            acolhedor. Tenho a certeza que entre as oportunidades que surgiram
            em 2017, o Grupo Krause foi a escolha certa."
          </p>
        </div>
        <div className="testimony-card">
          <div className="testimony-card-title">
            <img
              src={WorkerImg3}
              alt="Colaborador"
              className="testimony-card-img"
            />
            <div>
              <h3
                style={{
                  color: props.titleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Ederson Sidinei da Silva
              </h3>
              <h4 style={{ color: props.textColor, fontSize: props.textSize }}>
                Atendente Funerário Júnior
              </h4>
            </div>
          </div>
          <p style={{ color: props.textColor, fontSize: props.subTextSize }}>
            "Estou trabalhando na funerária do Grupo Krause, já faz 2 anos e 8
            meses. Uma empresa excelente, tenho construído um grande aprendizado
            para mim. Desde que comecei minha carreira tem evoluído
            constantemente. O ambiente e a visão de trabalho colaborativo têm
            sido fundamentais nesse crescimento. Valorizo as oportunidades de
            aprender com os colegas, que me incentivam diariamente. Nessa minha
            trajetória ascendente, quero continuar contribuindo para o
            crescimento contínuo do Grupo Krause."
          </p>
        </div>
        <div className="testimony-card">
          <div className="testimony-card-title">
            <img
              src={WorkerImg4}
              alt="Colaborador"
              className="testimony-card-img"
            />
            <div>
              <h3
                style={{
                  color: props.titleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Maria Eduarda Trevizani Carvalho
              </h3>
              <h4 style={{ color: props.textColor, fontSize: props.textSize }}>
                Assistente Administrativo Júnior
              </h4>
            </div>
          </div>
          <p style={{ color: props.textColor, fontSize: props.subTextSize }}>
            "Minha trajetória no Grupo Krause começou em 2021. Iniciei como
            Jovem Aprendiz no setor administrativo. Conforme foi passando o
            tempo, comecei a ficar mais na recepção no turno que eu vinha para a
            empresa, fui aprendendo como era os procedimentos e olhando como o
            atendimento com o cliente. Então, em janeiro de 2023 tive a
            oportunidade de ser efetivada, desde então comecei a trabalhar turno
            integral como aux. administrativo. Agradeço muito por essa
            oportunidade e sou muito grata ao Grupo Krause."
          </p>
        </div>
        <div className="testimony-card">
          <div className="testimony-card-title">
            <img
              src={WorkerImg5}
              alt="Colaborador"
              className="testimony-card-img"
            />
            <div>
              <h3
                style={{
                  color: props.titleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Lidiane Miranda Cassel
              </h3>
              <h4 style={{ color: props.textColor, fontSize: props.textSize }}>
                Analista Financeiro Sênior
              </h4>
            </div>
          </div>
          <p style={{ color: props.textColor, fontSize: props.subTextSize }}>
            "Iniciei no Grupo Krause como aux. de limpeza em out/23, um ano
            depois fui promovida para assist. financeiro, tenho orgulho de fazer
            parte dessa empresa que valoriza e incentiva seus colaboradores a
            crescer profissionalmente, demonstrar o amor ao próximo em nossos
            atendimentos é a motivação para eu estar aqui todos os dias!"
          </p>
        </div>
        <div className="testimony-card">
          <div className="testimony-card-title">
            <img
              src={WorkerImg6}
              alt="Colaborador"
              className="testimony-card-img"
            />
            <div>
              <h3
                style={{
                  color: props.titleColor,
                  fontSize: props.subTitleSize,
                }}
              >
                Cristhianne Kayser Bossle
              </h3>
              <h4 style={{ color: props.textColor, fontSize: props.textSize }}>
                Coordenadora RH
              </h4>
            </div>
          </div>
          <p style={{ color: props.textColor, fontSize: props.subTextSize }}>
            "São 6 anos de Grupo Krause. Orgulho em fazer parte dessa empresa
            com olhar tão humano, seja para clientes ou colaboradores. A empresa
            nos incentiva ao desenvolvimento, para evoluirmos de forma
            consistente. Muito bom estar num ambiente que converge com meus
            valores pessoais e objetivos profissionais."
          </p>
        </div>
      </Carousel>
    </Container>
  );
}
